import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { FertilizerEvent, updateFertilizerEvent, useAppDispatch } from "model";
import { Dispatch, SetStateAction } from "react";

import { StyledInputContainer } from "features/StyledInputContainer";
import EnterFertilizerEvent from "./EnterFertilizerEvent";
import {
  convertFromFormInput,
  FertilizerEventFormData,
} from "./FertilizerEventFormData";

export default function UpdateFertilizerEvent({
  fertilizerEvent,
  dialogOpen,
  setDialogOpen,
}: {
  fertilizerEvent: FertilizerEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setDialogOpen(false);
    mixpanel.track("Update fertilizer event cancelled");
  };

  async function handleSave(
    fertilizerEventFormData: FertilizerEventFormData,
    farmGuid: string | undefined
  ) {
    const fertilizerEventBody = convertFromFormInput(fertilizerEventFormData);
    await dispatch(
      updateFertilizerEvent({
        fertilizerEvent: { ...fertilizerEvent, ...fertilizerEventBody },
      })
    );
    notify(t("updateFertilizerEvent.add.success"));
    mixpanel.track("Fertilizer event updated");
    handleClose();
  }
  return (
    <Dialog
      fullScreen={isMobile}
      maxWidth="md"
      disableEscapeKeyDown
      open={dialogOpen}
      onClose={handleClose}
    >
      <StyledInputContainer isMobile={isMobile}>
        {
          <EnterFertilizerEvent
            fertilizerEvent={fertilizerEvent}
            handleSave={handleSave}
            handleClose={() => {
              handleClose();
            }}
            fieldSelectDisabled={false}
          />
        }
      </StyledInputContainer>
    </Dialog>
  );
}
